var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.stateClass},[_c('div',[_c(_vm.resultsView,{tag:"component"})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading ),expression:"isLoading "}],staticClass:"spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }